(function() {
    const c24 = window.c24;

    c24.lp.initAnchorScroll = {

        init: function() {
            setTimeout(c24.lp.initAnchorScroll.updateScrollTop, 500);
        },

        getScrollTop: function($target, noslide) {
            let scrollTop = $target.offset().top;

            /**
             * Auto scroll above accordion header
             */
            if ($target.closest('.c24Accordion').length) {
                let header = $target.closest('.c24Header');
                let content = header.next('.c24Content');

                if (!header.length) {
                    header = $target.closest('li');
                    content = $('div', header).first();
                }

                if (header.length) {
                    scrollTop = header.offset().top;
                    header.addClass('c24Open');
                    header.addClass('keepOpen');

                    if (noslide) {
                        content.show();
                        scrollTop -= 20;
                    } else {
                        content.stop().slideDown(200);
                    }
                }
            }
            scrollTop -= 5;

            /**
             * Auto move scrollTop by sticky header size
             */
            const adjust = $('.js24Sticky').length ? $('.js24Sticky') : $('.js24Fixable');
            let additionalValue = 0;

            if ($('.js24Fixable').hasClass('js24Fixed')) {
                additionalValue = 10;
            } else {
            // add 48 because fixed teaser is allways 48px heigher
                additionalValue = 58;
            }

            if (adjust.length) {
                scrollTop -= adjust.outerHeight() + additionalValue;
            }

            return scrollTop;
        },

        updateScrollTop: function() {
            // Consider fixable also if the jump is opened in a new window
            if (
                window.location.hash !== '#'
                && window.location.hash !== ''
            ) {
                const $target = $(window.location.hash);

                if ($target.length > 0) {
                    const scrollTop = c24.lp.initAnchorScroll.getScrollTop($target, true);
                    $('html, body').scrollTop(scrollTop);
                }
            }
        },
    };

    $(document).ready(function() {
        window.c24LpCssLoaded.then(function() {
            c24.lp.initAnchorScroll.init();
        });
    });
})();
